import { useState, useEffect, useRef } from "react";
import style from "./Tabs.module.css";

const Tabs = (props) => {
  const containerRef = useRef(null);
  const tabRefs = useRef([]);
  const [pillStyle, setPillStyle] = useState({ left: 0, width: 0, height: 0 });

  const isToggle = props.variants && props.variants.includes("toggle");

  useEffect(() => {
    if (!isToggle || !containerRef.current) return;

    const selectedIndex = props.tabs.findIndex((tab) => tab.selected);
    if (selectedIndex === -1) return;

    const selectedTab = tabRefs.current[selectedIndex];
    if (!selectedTab) return;

    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();
    const tabRect = selectedTab.getBoundingClientRect();

    setPillStyle({
      left: tabRect.left - containerRect.left,
      width: tabRect.width,
      height: tabRect.height,
    });
  }, [props.tabs, isToggle]);

  return (
    <div
      ref={containerRef}
      className={`${style.tabs} ${props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      }`}
    >
      {isToggle && pillStyle.width > 0 && (
        <div
          className={style.pill}
          style={{
            left: `${pillStyle.left}px`,
            width: `${pillStyle.width}px`,
            height: `${pillStyle.height}px`,
          }}
        />
      )}
      {props.tabs.map((tab, index) => (
        <li
          key={index}
          ref={(el) => (tabRefs.current[index] = el)}
          className={`${tab.selected && style.selected}`}
          onClick={tab.onClick}
        >
          {tab.name}
        </li>
      ))}
    </div>
  );
};

export default Tabs;
